module.exports = __webpack_public_path__ + "img/deal-car-2.246af539.png";